import React, { useCallback, useEffect, useMemo, memo } from "react";
import { ModalContent } from "../../../../components/Layout/Modals/ModalSimple";
import {
  IconChevronDownSolid,
  IconChevronUpSolid,
  IconDot,
  IconEdit,
  IconWarehouse3,
} from "../../../../components/Layout/Icons";
import styled from "styled-components";
import { useState } from "react";
import { InitialData, ProgressCircle } from "../../../../components/globals";
import { AiOutlineUser } from "react-icons/ai";
import { removeDuplicates } from "../../../../helpers/array";
import TableUi from "../../../../components/Layout/TableUI";
import { Modal, Tooltip } from "antd";
import useFetch from "../../../../hooks/useFetch";
import { prettyDateFormat, uniqueArray } from "../../../../helpers/Utils";
import AntdConfirm from "../../../../helpers/AntdConfirm";
import {
  orderActionLogRegenerate,
  orderActionLogUpdate,
} from "../../../../redux/Actions/order_action_log_action";
import { createConsumer } from "@rails/actioncable";
import { addOverFlow, removeOverFlow } from "../../../../helpers/modalFunc";
import ShipmentBuilder from "../items/ShipmentBuilder";
import Spinner from "../../../../components/common/Spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  setCountriesOptions,
  setParcelTerminalsOptions,
  setPickupAddressesOptions,
} from "../../../../redux/Actions/options_action";
import OrderRow from "../items/order_row_index/OrderRow";
import { cleanBulkAction } from "../../../../redux/Actions/bulk_shipment_action";

const status_colors = {
  success: "#A6D0A8",
  error: "#E07580",
  in_progress: "#03B0F7",
};

const status_colors_light = {
  success: "#A6D0A8",
  error: "#F9DDE0",
  in_progress: "#edf9fe",
};

const PreliminaryRendering = ({ active, openOrder, closeModal }) => {
  const [updatedData, setUpdatedData] = useState(null);
  useEffect(() => {
    const consumer = createConsumer();
    let subscription;

    if (active) {
      subscription = consumer.subscriptions.create(
        { channel: "ActionLogChannel" },
        {
          connected() {
            console.log("Connected WS ActionLogChannel!");
          },
          received(data) {
            if (data?.data) {
              console.log("ActionLogChannel: ", data.data);
              setUpdatedData(data.data);
            }
          },
        }
      );
      addOverFlow();
    } else {
      removeOverFlow();
    }

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
      consumer.disconnect();
    };
  }, [active]);

  const openOrderCallBack = useCallback((order_id) => {
    console.log(`Opening order with ID: ${order_id}`);
    openOrder(order_id);
  }, []);

  const closeModalCallBack = useCallback(() => {
    console.log(`Close modal`);
    closeModal();
  }, []);
  if (!active) return null;

  return (
    <ModalBulkActionPreviewHistory
      updatedData={updatedData}
      openOrder={openOrderCallBack}
      closeModal={closeModalCallBack}
    />
  );
};

export default PreliminaryRendering;

const ModalBulkActionPreviewHistory = memo(
  ({ updatedData, openOrder, closeModal }) => {
    console.count("ModalBulkActionPreviewHistory");
    const { value, loading, error, setValue, setReFetch } = useFetch(
      "/api/v1/action_logs.json"
    );

    useEffect(() => {
      if (!loading && !error && value && updatedData) {
        console.log("Updating item");
        setValue((prev) => {
          let data = { ...prev };
          console.log(
            "%cupdatedData",
            "color: blue; background: yellow; font-size: 18px;"
          );
          console.log(updatedData);
          if (updatedData.type == "delete") {
            data.data = data.data.filter((item) => item.id !== updatedData.id);
          } else if (updatedData.type == "create") {
            data.data.push(updatedData);
          } else if (updatedData.type == "update") {
            data.data = data.data.map((item) =>
              item.id == updatedData.id ? { ...item, ...updatedData } : item
            );
          }
          return data;
        });
      }
    }, [updatedData]);

    const data = useMemo(() => {
      if (loading) return [];
      if (!!error) return [];
      const unique = uniqueArray(value.data.map((item) => item.bulk_uuid));
      console.log({ unique });
      const rebuilded = unique.map((uuid) => {
        const actions = value.data.filter((item) => item.bulk_uuid === uuid);
        const firstAction = actions[0];
        const rebuild = actions.map((item) => {
          return {
            uuid,
            id: item.id,
            ...item.order,
            status: item.action_status,
            message: item.error,
            data: item.data,
            suppliers: item.suppliers,
            all_errors: item.all_errors || [],
          };
        });
        return {
          uuid,
          created_at: prettyDateFormat(firstAction.created_at),
          full_name: firstAction.full_name,
          regeneration_times: firstAction.regeneration_times,
          actions: rebuild,
        };
      });
      // console.log({ rebuilded });
      return rebuilded.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    }, [loading, value, error]);

    // functions
    const onRegenerate = useCallback((uuid) => {
      AntdConfirm({
        title: "Are you sure you want to regenerate action logs?",
        onOk: () => {
          orderActionLogRegenerate(uuid).then((res) => {
            if (res.success) {
              setReFetch();
            }
          });
        },
      });
    }, []);

    // const onDelete = useCallback((uuid, id) => {
    //   AntdConfirm({
    //     title: `Are you sure you want to delete action log${uuid ? "s" : ""}?`,
    //     onOk: () => {
    //       orderActionLogDelete(uuid, id).then((res) => {
    //         if (res.success) {
    //           setValue((prev) => {
    //             let data = { ...prev };
    //             if (id) {
    //               data.data = data.data.filter((item) => item.id !== id);
    //             } else if (uuid) {
    //               data.data = data.data.filter((item) => !item.uuid.includes(uuid));
    //             }
    //             return data;
    //           });
    //         }
    //       });
    //     },
    //   });
    // }, []);
    // console.log({ data });

    return (
      <>
        <div
          className={"modal-backdrop"}
          style={{
            zIndex: 108,
          }}
        />
        <div
          style={{
            margin: 0,
            position: "fixed",
            top: 0,
            left: 0,
            width: "25%",
            // width: "100%",
            zIndex: 110,
          }}
        >
          <ModalContent
            text={"Actions history"}
            onClose={() => closeModal()}
            hide={true}
            left={true}
          >
            {loading || error || !value ? (
              <InitialData loading={loading} error={error} value={value} />
            ) : (
              <div className="m-2">
                {data.map((history) => {
                  return (
                    <ActionBlockByUuid
                      key={history.uuid}
                      history={history}
                      openOrder={openOrder}
                      onRegenerate={onRegenerate}
                      // onDelete={onDelete}
                    />
                  );
                })}
              </div>
            )}
          </ModalContent>
        </div>
      </>
    );
  }
);

const ActionBlockByUuid = memo(({ history, openOrder, onRegenerate }) => {
  console.count("ActionBlockByUuid");
  const [active, setActive] = useState(false);
  return (
    <div>
      <ApplyActionItemStyled className="mb-2" active={active}>
        <div
          className={`d-flex justify-content-between align-items-center px-3 ${
            active ? "block-header" : ""
          } py-2`}
        >
          <div>
            <div
              className="d-flex align-items-center cursor-pointer"
              onClick={() => {
                setActive((prev) => !prev);
              }}
            >
              <div className="text-sm font-medium mr-2">
                {history.created_at}
              </div>
              <div className="text-sm">
                <AiOutlineUser className="mr-1" />
                {history.full_name}
              </div>
            </div>
            <div
              style={{
                marginLeft: "-6px",
              }}
            >
              <ActionStatus
                regeneration_times={history.regeneration_times}
                actions={history.actions}
                onRegenerate={() => onRegenerate(history.uuid)}
              />
            </div>
          </div>
          <div className="d-flex align-items-center">
            {/* {history.actions.every(
                (action) => action.status === "success"
              ) && (
                  <Tooltip placement="top" title="Delete">
                    <IconTrash
                      color="#797979"
                      className="mr-2 cursor-pointer"
                      onClick={() => onDelete(history.uuid)}
                    />
                  </Tooltip>
                )} */}
            <div
              className="cursor-pointer"
              onClick={() => {
                setActive((prev) => !prev);
              }}
            >
              {active ? <IconChevronDownSolid /> : <IconChevronUpSolid />}
            </div>
          </div>
        </div>

        {active && (
          <ActionPreviewByUuid
            actions={history.actions}
            openOrder={openOrder}
            // onDelete={onDelete}
          />
        )}
      </ApplyActionItemStyled>
    </div>
  );
});

const ActionPreviewByUuid = memo(({ actions, openOrder }) => {
  console.count("ActionPreviewByUuid");
  const data = useMemo(() => {
    const suppliers = removeDuplicates(
      actions.map((action) => action.suppliers)
    );
    return suppliers.map((supplier) => {
      const reActions = actions.filter(
        (action) => action.suppliers === supplier
      );
      const supplier_status = reActions.every(
        (action) => action.status === "success"
      )
        ? "success"
        : reActions.some((action) => action.status == "in_progress")
        ? "in_progress"
        : "error";

      return {
        supplier,
        supplier_status,
        supplier_count: reActions.filter(
          (action) => action.status === supplier_status
        ).length,
        actions: reActions,
      };
    });
  }, [actions]);

  return (
    <div className="p-2 bg-white">
      {data.map((action) => {
        return (
          <ActionBlockBySupplier
            key={action.supplier}
            action={action}
            openOrder={openOrder}
            // onDelete={onDelete}
          />
        );
      })}
    </div>
  );
});

const ActionBlockBySupplier = memo(({ action, openOrder }) => {
  console.count("ActionBlockBySupplier");
  const [active, setActive] = useState(false);
  return (
    <div>
      <ApplyActionItemStyled className="mb-2">
        <div
          className={`d-flex justify-content-between align-items-center px-3 cursor-pointer bg-white py-2`}
          onClick={() => {
            setActive((prev) => !prev);
          }}
        >
          <div>
            <div className="d-flex align-items-center">
              <IconWarehouse3 />
              <div className="text-sm font-medium ml-2 mr-3">
                {action.supplier}
              </div>
              <div>
                <IconDot fill={status_colors[action.supplier_status]} />
                {action.supplier_status == "error" && (
                  <span>{action.supplier_count} errors</span>
                )}
                {action.supplier_status == "in_progress" && (
                  <span>{action.supplier_count} in progress</span>
                )}
                {action.supplier_status == "success" && (
                  <span>{action.supplier_count} All orders went fine</span>
                )}
              </div>
            </div>
          </div>
          {active ? <IconChevronDownSolid /> : <IconChevronUpSolid />}
        </div>

        {active && (
          <ActionPreviewBySupplier
            success={action.supplier_status == "success"}
            actions={action.actions}
            openOrder={openOrder}
            // onDelete={onDelete}
          />
        )}
      </ApplyActionItemStyled>
    </div>
  );
});

const ActionPreviewBySupplier = memo(({ success, actions, openOrder }) => {
  console.count("ActionPreviewBySupplier");
  console.log({ actions });
  return (
    <div className="table-responsive">
      <TableUi
        className={"table-striped mb-0"}
        ths_expanded={[
          { label: "Order", style: { width: "30%" } },
          { label: success ? "Fixed erros" : "Error", style: { width: "70%" } },
        ]}
      >
        {actions.map((e) => {
          return (
            <Action
              key={"actions_" + e.id}
              value={e}
              openOrder={openOrder}
              success={success}
              // onDelete={onDelete}
            />
          );
        })}
      </TableUi>
    </div>
  );
});

const Action = ({ value: e, openOrder, success }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  return (
    <TableUi.tr>
      <TableUi.td className={"p-left"}>
        <div>
          <span
            className="d-flex align-items-center justify-content-between text-sm cursoir-pointer"
            style={{
              padding: "4px 5px 6px",
              borderRadius: 2,
              backgroundColor:
                e.status !== "success"
                  ? status_colors_light[e.status]
                  : "#EEEEEE",
              color: "#212529",
            }}
          >
            <span
              className="cursor-pointer"
              onClick={() => openOrder(e.order_id)}
            >
              {e.id_order}
            </span>
            {/* {e.status == "error" && (
              <IconTrash
                className="ml-2 cursor-pointer"
                color="#E07580"
                onClick={() => onDelete(null, e.id)}
              />
            )} */}
          </span>
        </div>
      </TableUi.td>
      <TableUi.td>
        <p>{e.message}</p>
        {e.status == "error" && (
          <>
            <div className="d-flex align-items-center">
              <div className="text-sm font-bold mr-2">Edit</div>
              <IconEdit
                onClick={() => {
                  dispatch(cleanBulkAction());
                  setOpen(true);
                }}
              />
            </div>
            {open && (
              <Modal
                title={"Bulk action edit"}
                centered
                open={open}
                onOk={async () => {
                  const { success } = await dispatch(
                    orderActionLogUpdate(e.id)
                  );
                  if (success) {
                    setOpen(false);
                  }
                  return 1;
                }}
                onCancel={() => {
                  dispatch(cleanBulkAction());
                  setOpen(false);
                }}
                width={400}
              >
                <RenderShipping data={e.data} />
              </Modal>
            )}
          </>
        )}
        {success &&
          e.all_errors.map((error, idx) => (
            <div key={idx} className="text-sm">
              {error}
            </div>
          ))}
      </TableUi.td>
    </TableUi.tr>
  );
};

const RenderShipping = ({ data }) => {
  const dispatch = useDispatch();
  const { countries, parcel_terminals, pickup_addresses } = useSelector(
    (state) => state.options
  );
  console.log({ data });
  const [order_id, order_params] = data;
  const { value, error, loading } = useFetch("/api/v1/orders/" + order_id);

  useEffect(() => {
    dispatch(setCountriesOptions());
    dispatch(setParcelTerminalsOptions());
    dispatch(setPickupAddressesOptions());
  }, []);

  const invoicesTotal = useMemo(() => {
    if (loading) return [];
    if (!value) return [];
    const o_invoices = [];
    value.invoices.forEach((e) => {
      if (e.identifier == "pre_invoice") return;
      if (e.order_invoice_order_rows?.length > 0) {
        e.order_invoice_order_rows.forEach((fr) => {
          if (o_invoices.includes(fr.order_row_id)) return;
          o_invoices.push(fr.order_row_id);
        });
      }
    });
    return o_invoices;
  }, [loading]);

  if (loading) {
    return <Spinner />;
  }
  if (error) {
    return <div>{JSON.stringify(error)}</div>;
  }

  const order_param = Array.isArray(order_params)
    ? order_params.at(0)
    : order_params;
  console.log("order_params: => ", { order_params, order_param });
  const order_rows = value.order_rows
    .map((row) => {
      const product = order_param.shipment_order_rows_attributes.find(
        (shipment_order_rows_attribute) =>
          shipment_order_rows_attribute.order_row_id == row.id
      );
      if (!product) return null;
      return {
        ...row,
        selected: true,
        checked: true,
        quantity: product.quantity,
      };
    })
    .filter((row) => row);

  console.log({ order_param });
  return (
    <div className="d-flex flex-column">
      {/* {JSON.stringify(value)}
      {JSON.stringify(error)}
      {JSON.stringify(loading)} */}

      <React.Fragment>
        <div
          style={
            {
              // width: 350
            }
          }
        >
          <div
            className="p-2"
            style={{
              borderBottom: open ? "1px solid #E8E8E8" : "none",
            }}
          >
            {order_rows.map((or_item) => {
              return (
                <OrderRow
                  type="shipping"
                  key={`or_item_${or_item.id}`}
                  {...or_item}
                  order_id={order_id}
                  invoicesTotal={invoicesTotal}
                  order_rows_accepted={true}
                  order_rows_accepted_func={() => {}}
                  handleSelected={() => true}
                  handleCheck={() => {}}
                />
              );
            })}
          </div>
          <ShipmentBuilder
            initial_pickup_address_id={order_param.pickup_address_id}
            supplying_ids={order_param.supplying_ids}
            order_rows={order_rows}
            initialServices={[]}
            order_id={order_id}
            additionalOptions={{
              pickup_addresses,
              countries,
              parcels: parcel_terminals,
            }}
            order_inf={{
              ...value.order,
              shipments: value.shipments,
              waiting_payments: value.waiting_payments,
            }}
            order_cart_rules={value.order_cart_rules}
            initialAddress={{
              ...order_param.shipment_address_attributes,
              firstname:
                order_param.shipment_address_attributes.name.split(" ")[0],
              lastname:
                order_param.shipment_address_attributes.name.split(" ")[1],
            }}
            initialValues={initialValuesSetter(
              order_param.shipment_additional_services_attributes
            )}
          />
        </div>
      </React.Fragment>
    </div>
  );
};

const initialValuesSetter = (shipment_additional_services_attributes) => {
  const values = {};
  shipment_additional_services_attributes.forEach((service) => {
    if (!!service.service_value) {
      if (service.service_key == "cod") {
        values[service.service_key] = true;
        values.cod_amount = +service.service_value;
      } else if (service.service_key == "pack") {
        values.packets = service.service_value;
      } else {
        values[service.service_key] = service.service_value;
      }
    }
  });
  return values;
};

const ApplyActionItemStyled = styled.div`
  background: #fcfcfc;
  border: 1px solid ${(props) => (props.active ? "#03B0F7" : "#d9d9d9")};
  border-radius: 4px;
  .block-header {
    background: #edf9fe;
    border-bottom: 1px solid #03b0f7;
    border-radius: 4px 4px 0px 0px;
  }
`;

const ActionStatus = memo(({ actions, regeneration_times, onRegenerate }) => {
  console.count("ActionStatus");
  const variables = useMemo(() => {
    const status = actions.every((action) => action.status === "success")
      ? "success"
      : actions.some((action) => action.status === "in_progress")
      ? "in_progress"
      : "error";
    const total_errors = actions.filter(
      (action) => action.status == "error"
    ).length;
    const unfinished = actions.filter(
      (action) => action.status !== "in_progress"
    );
    const percentage = (unfinished.length / actions.length) * 100;
    return {
      status,
      total_errors,
      percentage,
    };
  }, [actions]);

  return (
    <div className="d-flex align-items-center">
      <ProgressCircle
        percentage={variables.percentage}
        force_color={variables.total_errors > 0 ? "red" : ""}
      />
      {variables.total_errors > 0 ? (
        <span>
          Completed with {variables.total_errors} errors{" "}
          <div
            className="text-sm text-primary text-decoration-underline cursor-pointer"
            type="button"
            onClick={onRegenerate}
          >
            Regenerate
          </div>
        </span>
      ) : variables.status == "in_progress" ? (
        "In progress"
      ) : variables.status == "success" ? (
        "Completed"
      ) : null}

      {variables.status == "success" && !!regeneration_times && (
        <Tooltip placement="top" title="Regeneration times">
          <div
            className="bg-white text-xs text-center ml-1"
            style={{
              border: "1px solid #DEE2E6",
              borderRadius: 100,
              padding: "0 10px",
            }}
          >
            {regeneration_times}
          </div>
        </Tooltip>
      )}
    </div>
  );
});
